/// <reference types="./dirtyGetNextEntity.d.ts" />
/* eslint-disable @typescript-eslint/no-unused-expressions */
import { notOk, ok, } from '@dossierhq/core';
import { createSqliteSqlQuery, } from '@dossierhq/database-adapter';
import { ENTITY_DIRTY_FLAG_INDEX_LATEST, ENTITY_DIRTY_FLAG_INDEX_PUBLISHED, ENTITY_DIRTY_FLAG_VALIDATE_LATEST, ENTITY_DIRTY_FLAG_VALIDATE_PUBLISHED, } from '../DatabaseSchema.js';
import { queryNoneOrOne } from '../QueryFunctions.js';
import { assertIsDefined } from '../utils/AssertUtils.js';
import { resolveAdminEntityInfo, resolveEntityFields } from '../utils/CodecUtils.js';
export async function managementDirtyGetNextEntity(database, context, filter) {
    const { sql, query } = createSqliteSqlQuery();
    sql `WITH entities_cte AS (SELECT id FROM entities WHERE dirty != 0`;
    if (filter) {
        sql `AND uuid = ${filter.id}`;
    }
    sql `LIMIT 1)`;
    sql `SELECT e.id, e.uuid, e.type, e.name, e.auth_key, e.resolved_auth_key, e.created_at, e.updated_at, e.status, e.dirty, e.invalid, ev.version, ev.schema_version, ev.encode_version, ev.fields`;
    sql `FROM entities_cte, entities e, entity_versions ev WHERE entities_cte.id = e.id AND e.latest_entity_versions_id = ev.id`;
    const result = await queryNoneOrOne(database, context, query);
    if (result.isError())
        return result;
    if (!result.value) {
        return notOk.NotFound('No more dirty entities');
    }
    const { id: entityInternalId, uuid: id, resolved_auth_key: resolvedAuthKey, dirty, } = result.value;
    assertIsDefined(id);
    return ok({
        ...resolveAdminEntityInfo(result.value),
        ...resolveEntityFields(result.value),
        entityInternalId,
        id,
        resolvedAuthKey,
        dirtyValidateLatest: !!(dirty & ENTITY_DIRTY_FLAG_VALIDATE_LATEST),
        dirtyValidatePublished: !!(dirty & ENTITY_DIRTY_FLAG_VALIDATE_PUBLISHED),
        dirtyIndexLatest: !!(dirty & ENTITY_DIRTY_FLAG_INDEX_LATEST),
        dirtyIndexPublished: !!(dirty & ENTITY_DIRTY_FLAG_INDEX_PUBLISHED),
    });
}
//# sourceMappingURL=dirtyGetNextEntity.js.map